// extracted by mini-css-extract-plugin
module.exports = {"platinum":"_93444fe79c--platinum--j3tPs"};